import React from "react";
import { connect } from "react-redux";
import SettingsContainer from "./shared/SettingsContainer";
import EPRSSettings from "./EPRSSettings";
import EPRSCredentials from "./EPRSCredentials";
import translate from "../../../i18n/translate";

// Login (url, user, password, test) and the product sync. The EPRS settings
// table holds nothing else, so there is no third tab.
const EPRSSettingsContainer = ({ isDarktheme }) => {
  return (
    <SettingsContainer
      isDarktheme={isDarktheme}
      componentId="eprs"
      tabLabels={[translate("Login"), translate("Update EPRS")]}
      tabComponents={[EPRSCredentials, EPRSSettings]}
    />
  );
};

const mapStateToProps = ({ darkTheme: { isDarktheme } }) => ({
  isDarktheme,
});

export default connect(mapStateToProps, null)(EPRSSettingsContainer);
